import { createCustomEvent } from '../../../../core/runtime/src/utils/events';
import { clamp } from '../../../progress-bar/src/utils';
var MIN_PANEL_WIDTH = 280;
var ResizeHandler = /** @class */ (function () {
    function ResizeHandler(component, updater) {
        var _this = this;
        this.component = component;
        this.updater = updater;
        this.panelSizes = {};
        this.drawerElement = null;
        this.activeDrawer = null;
        this.startXOffset = 0;
        this.startWidth = 0;
        this.maxWidth = 0;
        this.maybeStartDrag = function (event) {
            if (event.button !== 0) {
                return;
            }
            var dragHandle = _this.rootElement.querySelector('.awsui-app-layout__resize-handle');
            if (dragHandle && (event.target === dragHandle || dragHandle.contains(event.target))) {
                _this.startDrag(event);
            }
        };
        this.startDrag = function (event) {
            _this.activeDrawer = _this.component.__drawers.filter(function (drawer) { return drawer.id === _this.component.__activeDrawerId; })[0];
            _this.startXOffset = event.clientX;
            _this.drawerElement = _this.rootElement.querySelector('.awsui-app-layout__tools');
            _this.startWidth = _this.drawerElement.getBoundingClientRect().width;
            _this.maxWidth = _this.updater.getDrawerMaxWidth();
            document.body.classList.add('awsui-app-layout--resize-active');
            document.addEventListener('mousemove', _this.handleMove);
            document.addEventListener('mouseup', _this.endDrag);
        };
        this.handleMove = function (event) {
            var width = _this.startWidth - (event.clientX - _this.startXOffset);
            width = clamp(width, MIN_PANEL_WIDTH, _this.maxWidth);
            _this.panelSizes[_this.activeDrawer.id] = width;
            _this.drawerElement.style.width = width + 'px';
        };
        this.endDrag = function () {
            var _a, _b;
            document.body.classList.remove('awsui-app-layout--resize-active');
            document.removeEventListener('mousemove', _this.handleMove);
            document.removeEventListener('mouseup', _this.endDrag);
            (_b = (_a = _this.activeDrawer).onResize) === null || _b === void 0 ? void 0 : _b.call(_a, createCustomEvent('awsui', {
                size: _this.panelSizes[_this.activeDrawer.id],
                id: _this.activeDrawer.id
            }));
            _this.activeDrawer = null;
        };
        this.rootElement = component.node;
    }
    ResizeHandler.prototype.attach = function () {
        this.rootElement.addEventListener('mousedown', this.maybeStartDrag);
    };
    ResizeHandler.prototype.detach = function () {
        this.rootElement.removeEventListener('mousedown', this.maybeStartDrag);
    };
    return ResizeHandler;
}());
export { ResizeHandler };
//# sourceMappingURL=resize-handler.js.map